// @flow

import * as React from 'react';
import {defineMessages, FormattedMessage} from 'react-intl';
import {actionsRolesAllow} from './ActionsRolesAllow';
import type {RoleDescriptionProps} from './RoleDescription';

const issuingSupportAgentRoleMessages = defineMessages({
  roleName: {
    id:
      'docsApp.components.contrib.roleDescriptions.issuingSupportAgentRole.roleName',
    description: 'The name of the Issuing support agent role',
    defaultMessage: 'Issuing Support Agent',
  },
  descriptionOfWhatRoleCanDo: {
    id:
      'docsApp.components.contrib.roleDescriptions.issuingSupportAgentRole.descriptionOfWhatRoleCanDo',
    description:
      'The description of what the Issuing support agent role can do',
    defaultMessage:
      'This role is for Issuing users who need to create disputes and edit authorization and transaction metadata.',
  },
  descriptionOfWhatRoleCannotDo: {
    id:
      'docsApp.components.contrib.roleDescriptions.issuingSupportAgentRole.descriptionOfWhatRoleCannotDo',
    description:
      "The description of what the Issuing support agent role can't do",
    defaultMessage: "This role can't create cards or cardholders.",
  },
});

const issuingRoleDescriptionProps: RoleDescriptionProps = {
  roleName: <FormattedMessage {...issuingSupportAgentRoleMessages.roleName} />,
  roleExternalId: 'issuing_support_agent',
  isBeta: false,
  descriptionOfWhatRoleCanDo: (
    <FormattedMessage
      {...issuingSupportAgentRoleMessages.descriptionOfWhatRoleCanDo}
    />
  ),
  descriptionOfWhatRoleCannotDo: (
    <FormattedMessage
      {...issuingSupportAgentRoleMessages.descriptionOfWhatRoleCannotDo}
    />
  ),
  someThingsThisRoleCanDo: [
    <FormattedMessage {...actionsRolesAllow.createViewEditIssuingDisputes} />,
    <FormattedMessage {...actionsRolesAllow.viewEditIssuingAuthorizations} />,
    <FormattedMessage {...actionsRolesAllow.viewEditIssuingTransactions} />,
    <FormattedMessage {...actionsRolesAllow.viewIssuingCards} />,
    <FormattedMessage {...actionsRolesAllow.viewIssuingCardholders} />,
  ],
  someThingsThisRoleCannotDo: [
    <FormattedMessage {...actionsRolesAllow.createEditDeleteIssuingCards} />,
    <FormattedMessage
      {...actionsRolesAllow.createEditDeleteIssuingCardholders}
    />,
    <FormattedMessage {...actionsRolesAllow.viewTransfers} />,
    <FormattedMessage {...actionsRolesAllow.viewBalance} />,
    <FormattedMessage {...actionsRolesAllow.viewPayments} />,
    <FormattedMessage {...actionsRolesAllow.viewPayouts} />,
    <FormattedMessage {...actionsRolesAllow.addFunds} />,
    <FormattedMessage {...actionsRolesAllow.createEditDeleteAPIKeys} />,
    <FormattedMessage {...actionsRolesAllow.addEditRemoveTeamMembers} />,
    <FormattedMessage {...actionsRolesAllow.editAccountDetails} />,
    <FormattedMessage {...actionsRolesAllow.changeAccountOwner} />,
    <FormattedMessage {...actionsRolesAllow.configureAnyProductSettings} />,
  ],
};

export const allIssuingRoleProps = [issuingRoleDescriptionProps];
